// services/InformeActas/InformeActasService.js
import axios from "axios";
import config from "../../config";

const baseUrl = config.baseUrl;

export const getInformeActasData = async (params = {}) => {
  try {
    const response = await axios.get(`${baseUrl}/api/informeActasData`, {
      params, // ruta, nivel, etc.
      maxBodyLength: Infinity,
    });
    return response.data;
  } catch (error) {
    console.error("Error al obtener informe de actas:", error);
    throw error;
  }
};

export const obtenerArchivos = async (params = {}) => {
  try {
    const response = await axios.get(`${baseUrl}/api/documentosEliminar/`, {
      params,
      maxBodyLength: Infinity,
    });
    return response.data;
  } catch (error) {
    console.error("Error al obtener archivos con datos:", error);
    throw error;
  }
};

export const eliminarArchivos = async (rutas, observacion, usuario) => {
  try {
    const payload = { rutas, observacion, usuario }; // 👈 backend espera esto

    const response = await axios.delete(`${baseUrl}/api/documentosEliminar/`, {
      data: payload,
    });

    return response.data;
  } catch (error) {
    console.error("Error al eliminar archivos:", error);
    throw error;
  }
};

export const calcularEstadisticas = (archivos) => {
  if (!archivos || archivos.length === 0) {
    return {
      totalArchivos: 0,
      archivosPorUsuario: {},
      archivosPorEstado: {},
      archivosPorTipo: {},
    };
  }

  const stats = {
    totalArchivos: archivos.length,
    archivosPorUsuario: {},
    archivosPorEstado: {},
    archivosPorTipo: {},
  };

  archivos.forEach((archivo) => {
    // Contar por usuario
    const usuario = archivo.json?.user || "Sin usuario";
    stats.archivosPorUsuario[usuario] =
      (stats.archivosPorUsuario[usuario] || 0) + 1;

    // Contar por estado
    const estado = archivo.json?.estado || "Sin estado";
    stats.archivosPorEstado[estado] =
      (stats.archivosPorEstado[estado] || 0) + 1;

    // Contar por tipo de archivo (extensión)
    const extension = archivo.nombre?.split(".").pop()?.toUpperCase() || "UNKNOWN";
    stats.archivosPorTipo[extension] =
      (stats.archivosPorTipo[extension] || 0) + 1;
  });

  return stats;
};
